import type { IState } from 'redux/state';
import { createSelector } from 'reselect';
import { getCurrentlyViewedProjectId } from './projects.shared';

const readProjectSubscriptions = (state: IState) => state.projectSubscriptions.data;

export const getProjectSubscriptions = createSelector(
  [getCurrentlyViewedProjectId, readProjectSubscriptions],
  (projectId, subscriptions) => {
    if (!projectId) {
      return false;
    }
    const subscription = subscriptions[projectId];
    return !!(subscription && subscription.subscribed);
  }
);
